import React, { useEffect, useState, useCallback, useRef } from 'react';
import { FaTimes } from 'react-icons/fa';
import { rewriteLocalhostImageUrl, fetchAuthenticatedImageBlob, isUnitImageFile } from './unitImageHelpers';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const ImagesViewList = ({ attachments, setAttachments, createEmptyRow }) => {

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    // Preview renders inline in a panel under the grid rather than a popup
    // modal - a modal read as "nothing visible happened" behind whatever was
    // rendering it. { url, isBlob, loading, error, rawUrl } - same reasoning
    // as images.js: a plain <img src={fullUrl}> never carries this app's
    // auth headers and can 401 silently, so the saved image is fetched as an
    // authenticated blob instead of pointed at directly.
    const [previewImage, setPreviewImage] = useState(null);
    const previewRequestId = useRef(0);

    const handleView = async (row) => {
        const fullUrl = row?.fullUrl;
        if (!fullUrl) return;

        if (previewImage?.isBlob && previewImage?.url) {
            URL.revokeObjectURL(previewImage.url);
        }

        const rawUrl = rewriteLocalhostImageUrl(fullUrl);
        const requestId = ++previewRequestId.current;
        const isImage = isUnitImageFile(row, rawUrl);
        setPreviewImage({ url: null, isImage, isBlob: false, loading: true, error: false, rawUrl });
        try {
            const blob = await fetchAuthenticatedImageBlob(rawUrl);
            if (previewRequestId.current !== requestId) return;
            // A PDF served without a proper filename/extension still comes back
            // with an accurate blob.type - trust that over the extension guess.
            setPreviewImage({ url: URL.createObjectURL(blob), isImage: isImage || blob.type?.startsWith('image/'), isBlob: true, loading: false, error: false, rawUrl });
        } catch (error) {
            console.error('Error fetching image preview:', error);
            if (previewRequestId.current !== requestId) return;
            setPreviewImage({ url: null, isImage, isBlob: false, loading: false, error: true, rawUrl });
        }
    };
    const closePreview = () => {
        if (previewImage?.isBlob && previewImage?.url) {
            URL.revokeObjectURL(previewImage.url);
        }
        setPreviewImage(null);
    };

    useEffect(() => {
        return () => {
            if (previewImage?.isBlob && previewImage?.url) {
                URL.revokeObjectURL(previewImage.url);
            }
        };
    }, [previewImage]);

    return (
        <div className=''>
            <table className="table table-bordered">
                <thead className="dynoTable">
                    <tr>
                        <th>File Name</th>
                        <th>Remarks</th>
                        <th>Upload</th>
                        <th>View</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {attachments.map((row) => (
                        <tr key={row.id}>
                            <td>
                                <input disabled value={row.originalFileName} className="form-control" />
                            </td>

                            <td>
                                <input
                                    disabled
                                    value={row.remarks}
                                    className="form-control"
                                />
                            </td>

                            <td>
                                <input
                                    type="file"
                                    hidden
                                    id={`file-${row.id}`}
                                    disabled
                                />
                                <button
                                    className="mainbtn"
                                    disabled
                                >
                                    Upload
                                </button>
                            </td>

                            <td>
                                <button
                                    className="mainbtnRed"
                                    onClick={() => handleView(row)}
                                >
                                    View
                                </button>
                            </td>

                            <td>
                                <button
                                    className="mainbtnSecondary"
                                    disabled
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {previewImage && (
                <div className="mt-3 p-3" style={{ border: '1px solid #E5E7EB', borderRadius: '8px', background: '#FAFAFA' }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <strong>Preview</strong>
                        <FaTimes onClick={closePreview} style={{ cursor: 'pointer' }} title="Close" />
                    </div>
                    {previewImage.loading && <div className="text-center p-4">Loading...</div>}
                    {previewImage.error && (
                        <div className="text-center p-4">
                            <div className="mb-2">Unable to load preview</div>
                            {previewImage.rawUrl && (
                                <a href={previewImage.rawUrl} target="_blank" rel="noopener noreferrer">
                                    Open in new tab
                                </a>
                            )}
                        </div>
                    )}
                    {previewImage.url && !previewImage.loading && !previewImage.error && (
                        previewImage.isImage ? (
                            <img
                                src={previewImage.url}
                                alt="preview"
                                style={{ maxWidth: '100%', maxHeight: '600px', display: 'block', margin: '0 auto' }}
                            />
                        ) : (
                            <iframe
                                src={previewImage.url}
                                title="preview"
                                style={{ width: '100%', height: '600px', border: 'none' }}
                            />
                        )
                    )}
                </div>
            )}
        </div>
    )
}

export default ImagesViewList
